import React from 'react'

export default function Anotaciones() {
  return (
    <div>
      Anotaciones
    </div>
  )
}
